import { render, staticRenderFns } from "./shareDetail.vue?vue&type=template&id=ab0ba658&scoped=true&"
import script from "./shareDetail.vue?vue&type=script&lang=js&"
export * from "./shareDetail.vue?vue&type=script&lang=js&"
import style0 from "./shareDetail.vue?vue&type=style&index=0&id=ab0ba658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0ba658",
  null
  
)

export default component.exports